import { useEffect, useState } from 'react';

function useMediaQuery(query: string): boolean {
	const getMatches = (q: string): boolean => {
		// Prevents SSR issues
		if (typeof window !== 'undefined') {
			return window.matchMedia(q).matches;
		}
		return false;
	};

	const [matches, setMatches] = useState<boolean>(getMatches(query));

	function handleChange() {
		setMatches(getMatches(query));
	}

	useEffect(() => {
		handleChange();

		window?.addEventListener('resize', handleChange);

		return () => {
			window?.removeEventListener('resize', handleChange);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [query]);

	return matches;
}

export default useMediaQuery;
